import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import {ByTheFootInitialDataModel } from '../../models';
import {BytheFootSection } from '../../utils/index';

@Component({
  selector: 'spekwo-by-the-foot-section',
  templateUrl: './by-the-foot-section.component.html',
  styleUrls: ['./by-the-foot-section.component.scss']
})
export class ByTheFootSectionComponent implements OnInit {

  @Output() previousTotalCost = new EventEmitter<ByTheFootInitialDataModel>();
  @Input() type: string;
  @Input() defaultValues;
  @Output() closePanle = new EventEmitter<boolean>();
  @Input() enableClose: boolean;

  nameValues = BytheFootSection;
  panelOpenState = true;
  newAttribute: ByTheFootInitialDataModel = {
    cpf: null,
    tf: null,
    totalCost:null
  }
  constructor() { }

  ngOnInit() {
    if (this.type == this.nameValues.editType) {
      this.assignInitialValues();
      this.onPanelOpenState(true);
    }
  }

  onPanelOpenState(state: boolean) {
    this.panelOpenState = state;
  }

  //Assigning initial values if component called from edit
  assignInitialValues() {
    if (this.defaultValues.tf != null && this.defaultValues.cpf != null && this.defaultValues.totalCost != null) {
    _.map(this.newAttribute, (value, key) => {
      this.newAttribute[key] = (this.defaultValues[key]!=0)?this.defaultValues[key]:null;
    });
  }
  }

  //Calculating all cost values
  calculatedLaborCost() {
    this.newAttribute.totalCost =Number((Number(this.newAttribute.cpf) * Number(this.newAttribute.tf)).toFixed(2));
    this.previousTotalCost.emit(this.newAttribute);
  }

  close()
  {
    this.closePanle.emit(true);
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/common/by-the-foot-section/by-the-foot-section.component.ts